import { useMemo } from "react"

import { useCoachDirectReportsQuery } from "../networking/coachingGroups/queries"
import useAdmin from "../pages/admin/useAdmin"
import useCurrentClient from "../pages/clients/hooks/useCurrentClient"

export const useUserRole = () => {
  const { data: directReports } = useCoachDirectReportsQuery()
  const { currentCoachingGroup } = useCurrentClient()
  const isAdmin = useAdmin()

  const userHasDirectReports = directReports && directReports.length > 0
  const isSupervisor = userHasDirectReports && !isAdmin

  const isClientOfOtherCoach = useMemo(() => {
    if (!currentCoachingGroup) return false
    return directReports?.some((report) =>
      report.group_ids.includes(currentCoachingGroup.id)
    )
  }, [directReports, currentCoachingGroup])

  return { isSupervisor, isAdmin, isClientOfOtherCoach }
}

export default useUserRole
